import { useBalanceQuery, useEripTopUpQuery } from "@/__generated__/graphql";
import ErrorView from "@/components/layouts/ErrorView";
import LoadingView from "@/components/layouts/LoadingView";
import BalanceView from "../views/BalanceView";

export default function Balance() {
  const balanceQuery = useBalanceQuery();
  const topUpQuery = useEripTopUpQuery();

  if (balanceQuery.loading || topUpQuery.loading) {
    return <LoadingView />;
  }

  if (!balanceQuery.data || !topUpQuery.data) {
    return <ErrorView />;
  }

  return <BalanceView balance={balanceQuery.data.balance} topUp={topUpQuery.data.eripTopUp} />;
}
